import React, { useState, useRef } from "react";
import {  Button,  Stepper, Step, StepLabel, Card, CardContent } from "@mui/material";
import DisponibilidadSemanal from './FormularioDoctor/DisponibilidadSemanal';
import AddAdress from './FormularioDoctor/addAdress';
import AddAboutYou from './FormularioDoctor/addAboutYou';
import MedicDetail from './MedicDetail';

import AddDatosGenerales from './FormularioDoctor/addDatosGenerales';

const steps = ["Datos Generales", "Consultorio", "Experiencia", "Calendario", "Vista Previa"];

const DoctorForm = () => {
    const [formData, setFormData] = useState({
        DrName: "",
        DrSubName1: "", // Agregado para Apellido Paterno
        DrSubName2: "", // Agregado para Apellido Materno
        Charge: "",
        Phone: "",
        imageUrl: null,
        Services: "",
        Address: "",
        AddressMaps: "",
        Price: "",
        Experience: [],
        Specialization: [],
        Achievements: [],
        Duration: 30,
        AvailableSlots: [],
        Street: "",
        Colony: "",
        PostalCode: "",
        City: "",
    });
    const [activeStep, setActiveStep] = useState(0);
 
 
    const handleNext = () => {
        setActiveStep((prev) => prev + 1);
    };

    const handleBack = () => {
        setActiveStep((prev) => prev - 1);
    };

 

    // Función para recibir datos del hijo
    const handleFormGeneralData = (updatedData) => {
        setFormData(updatedData); // Actualiza el estado del padre con los datos del hijo
        console.log("Datos recibidos del hijo:", formData); // Para depuración
    };

 
    const handleStepClick = (stepIndex) => {
        setActiveStep(stepIndex); // Cambia al paso seleccionado
    };

    return (
        <div className="max-w-2xl mx-auto p-4">
            <div className="overflow-x-auto">
                <Stepper activeStep={activeStep}
                    alternativeLabel sx={{
                        '& .MuiStepLabel-label': {
                            fontSize: '0.75rem'
                        }
                    }}>
                    {steps.map((label, index) => (
                        <Step key={label} onClick={() => handleStepClick(index)}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
            </div>

            <Card className="mt-4 p-4 shadow-md">
                <CardContent>
                    {activeStep === 0 && (
                        <AddDatosGenerales onFormGeneralDataChange={handleFormGeneralData} perfildata={formData} />
                    )}
                    {activeStep === 1 && (
                        <AddAdress />
                    )}
                    {activeStep === 2 && (
                        <AddAboutYou />
                    )}
                    {activeStep === 3 && (
                        <DisponibilidadSemanal />
                    )}

                    {activeStep === 4 && (
                        <MedicDetail temporalMedic={formData} />
                    )}
                </CardContent>
            </Card>
            <div className="flex justify-between mt-4">
                {activeStep > 0 && <Button onClick={handleBack}>Atrás</Button>}
                <Button onClick={handleNext}>{activeStep === steps.length - 1 ? "Finalizar" : "Siguiente"}</Button>
            </div>
        </div>
    );
};

export default DoctorForm;
